import { useRef } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { trackProductListFilter } from '~/shared/actions';

const GridFilterSegmentEvents = ({
  filterKeys,
  currentFilters,
  currentSort,
  category,
  list,
}) => {
  const dispatch = useDispatch();
  const delayFireList = [];

  const prevFilters = useRef({});
  const prevSort = useRef('');

  const comparisonSort = Array.isArray(currentSort)
    ? currentSort[0].field
    : currentSort;

  const trackingSort =
    currentSort && !Array.isArray(currentSort)
      ? [{ field: currentSort }]
      : currentSort;

  if (Array.isArray(filterKeys)) {
    const { clear, add } = filterKeys.reduce(
      ({ clear, add }, filterKey) => {
        const prev = prevFilters.current[filterKey];
        const current = currentFilters[filterKey];

        if (Array.isArray(current) && Array.isArray(prev)) {
          const remove = prev.filter((filter) => !current.includes(filter));

          if (remove.length) {
            clear.push(
              ...remove.map((filterValue) => ({
                label: 'Clear',
                filter: { type: filterKey, value: filterValue },
              }))
            );
          }

          const difference = current.filter((filter) => !prev.includes(filter));

          if (difference.length) {
            add.push(
              ...difference.map((filterValue) => ({
                label: 'Apply',
                filter: { type: filterKey, value: filterValue },
              }))
            );
          }
        }

        return { clear, add };
      },
      { clear: [], add: [] }
    );

    const filterList = [...clear, ...add];

    filterList.forEach((filterInfo) => {
      delayFireList.push(() =>
        dispatch(
          trackProductListFilter({
            label: filterInfo.label,
            list_id: list,
            category,
            filters: filterInfo.filter,
            sort: trackingSort,
          })
        )
      );
    });

    prevFilters.current = currentFilters;
  }

  const isSortDifferent = prevSort.current !== comparisonSort;

  if (isSortDifferent) {
    delayFireList.push(() =>
      dispatch(
        trackProductListFilter({
          list_id: list,
          category,
          sort: trackingSort,
        })
      )
    );
  }

  prevSort.current = comparisonSort;

  delayFireList.forEach((fn, index) => setTimeout(fn, 250 * index));

  return null;
};

GridFilterSegmentEvents.propTypes = {
  category: PropTypes.array,
  currentFilters: PropTypes.object,
  currentSort: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  filterKeys: PropTypes.array,
  list: PropTypes.string,
};

export default GridFilterSegmentEvents;
